import { toBoolean } from '@mnd-frontend/ts';

const getContactName = (
  contact?: { firstName?: string | null; lastName?: string | null; email?: string | null },
  fallbackEmail = true,
): string => {
  const name = [contact?.firstName, contact?.lastName].filter(toBoolean).join(' ');
  return name || (fallbackEmail ? contact?.email : '') || '';
};

export default getContactName;
